import { combineReducers } from 'redux';

import { ENTITY_TYPE } from 'modules/app/constants';
import { FETCH_LINKED_AUDITS_REQUEST, FETCH_LINKED_AUDITS_SUCCESS } from 'modules/audits/actionTypes';
import loading from 'modules/global/reducers/generic.loading';
import { createReducer } from 'utils/ReduxUtils';

/**
 * @typedef {{
 *   loading: boolean,
 *   byEntity: Record<string, string[]>
 * }} LinkedEntitiesReducer
 */

const setLinkedEntities = (_, { payload }) => ({
  [ENTITY_TYPE.AUDIT]: payload.sameReferenceAudits.map(({ id }) => id),
  [ENTITY_TYPE.INTERVENTION]: payload.sameReferenceInterventions.map(({ id }) => id),
});

export default combineReducers({
  loading: loading(FETCH_LINKED_AUDITS_REQUEST),
  byEntity: createReducer({}, {
    [FETCH_LINKED_AUDITS_REQUEST]: () => ({}),
    [FETCH_LINKED_AUDITS_SUCCESS]: setLinkedEntities,
  }),
});
